function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCrossmark = function SvgCrossmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 210",
    style: {
      height: "1em",
      width: "auto"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 105,
    cy: 106.6,
    r: 21.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 105,
    cy: 106.6,
    r: 78.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 105,
    y1: 162.7,
    x2: 105,
    y2: 205
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 105,
    y1: 5,
    x2: 105,
    y2: 47.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 47.3,
    y1: 105,
    x2: 5,
    y2: 105
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 205,
    y1: 105,
    x2: 162.7,
    y2: 105
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crossmark.1a4b3bba.svg";
export { ForwardRef as ReactComponent };